import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { ButtonComponent, IconComponent } from '@mode/capra';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AcknowledgeForm, DialogHeaderComponent } from '@mode/shared/ui';
import { DatasetFacade } from '@mode/dataset/contract';
import { take } from 'rxjs/operators';

@Component({
  selector: 'mode-unpublish-dataset-dialog',
  standalone: true,
  imports: [CommonModule, ButtonComponent, DialogHeaderComponent, FormsModule, ReactiveFormsModule, IconComponent],
  providers: [TitleCasePipe],
  templateUrl: './unpublish-dataset-dialog.component.html',
  styleUrls: ['./unpublish-dataset-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnpublishDatasetDialogComponent {
  @Output() unpublish = new EventEmitter<{ datasetToken: string }>();

  readonly form = new AcknowledgeForm();
  dataset$ = this.datasetFacade.dataset$;

  constructor(
    protected dialogRef: MatLegacyDialogRef<UnpublishDatasetDialogComponent>,
    private datasetFacade: DatasetFacade
  ) {}

  unpublishDataset(): void {
    this.dataset$.pipe(take(1)).subscribe({
      next: (dataset) =>
        this.unpublish.emit({
          datasetToken: dataset.token,
        }),
    });

    this.close();
  }

  close() {
    this.dialogRef.close();
  }
}
